<template>
    <div class="apple-keyword-custom-tab">
        <el-tabs type="border-card" v-model="activeTabName" @tab-click="changeTab" @click.native="clickTabItem">
            <el-tab-pane label="关键词" name="apple_keyword" v-if="pageActionNames.includes('apple_keyword')">
                <div slot="label" class="apple-keyword-custom-tab-pane">关键词</div>
                <keywordPage v-if="activeTabName == 'apple_keyword'" ref="apple_keyword" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="zone" :range-time="rangeTime" />
            </el-tab-pane>
            <el-tab-pane label="搜索词" name="apple_search_term" v-if="pageActionNames.includes('apple_search_term')">
                <div slot="label" class="apple-keyword-custom-tab-pane">搜索词</div>
                <SearchTermPage v-if="activeTabName == 'apple_search_term'" ref="apple_search_term" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="zone" :range-time="rangeTime"/>
            </el-tab-pane>
            <el-tab-pane label="否定关键词" name="apple_negative_keyword" v-if="pageActionNames.includes('apple_negative_keyword')">
                <div slot="label" class="apple-keyword-custom-tab-pane">否定关键词</div>
                <NegativeKeywordPage v-if="activeTabName == 'apple_negative_keyword'" ref="apple_negative_keyword" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="zone" :range-time="rangeTime"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import keywordPage from './pages/keyword';
    import SearchTermPage from './pages/searchTerm';
    import NegativeKeywordPage from './pages/negativeKeyword';
    export default {
        name: "KeywordIndex",
        components:{
            keywordPage,
            SearchTermPage,
            NegativeKeywordPage,
        },
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageAction:Array,
        },
        data(){
            return {
                activeTabName:'',
            }
        },
        computed:{
            ...mapGetters(['tabs_map']),
            pageActionNames(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name);
            },
        },
        mounted(){
            this.activeTabName = this.$route.name;
            this.$store.commit('apple/SET_CUR_TAB_PAGE',this.$route.name);
        },
        methods:{
            changeTab(tab){
                let tabName = tab.name||'';
                this.$router.push({
                    name:tabName,
                    params:{
                        range:this.rangeTime,
                        zone:this.zone,
                    }
                });
            },
            clickTabItem(ev){
                let $target = ev.target.parentElement;
                let className = $target.className||'';
                let idName = $target.id||'';
                if(className.includes('is-active')&&className.includes('el-tabs__item')){
                    let tabNames = ['apple_keyword','apple_search_term','apple_negative_keyword'].map(item=>'tab-'+item);
                    if(tabNames.includes(idName)){
                        this.$nextTick(()=>{
                            this.$refs[this.activeTabName].getSearchList('clearTab');
                            console.log('刷新当前tab');
                        })
                    }
                }
            },
            updateZone(){
                this.$nextTick(()=>{
                    this.$refs[this.activeTabName].getSearchList();
                });
            },
            getSearchList(val){
                this.$nextTick(()=>{
                    this.$refs[this.activeTabName].getSearchList(val);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    /* 覆盖掉默认的Tab页样式 */
    .apple-keyword-custom-tab ::v-deep{
        .el-tabs__content{
            padding: 0;
        }

        .el-tabs--border-card{
            border: solid 1px #d7d7d7;
            box-shadow: none;
            border-top: none;
            &>.el-tabs__header .el-tabs__item.is-active{
                background-color: transparent;
                z-index: 99;
                border-left: 1px solid transparent;
            }
            &:before{
                content: '';
                display: block;
                position: absolute;
                top: -1px;
                right: 15px;
                height: 30px;
                width: 2px;
                background-color: #f1f4f9;
                z-index: 1;
            }
        }

        .el-tabs__header .el-tabs__nav-wrap{
            padding-left: 0!important;
            background: #F1F4F9;
            left: -1px;
            .el-tabs__nav-scroll:after{
                content: '';
                display: block;
                position: absolute;
                left: 0;
                right: 0;
                height: 1px;
                background-color: #d7d7d7;
                z-index: 1;
                bottom: 0;
            }
        }

        .el-tabs__nav .el-tabs__item:nth-of-type(2){
            left: -5px;
            z-index: 3;
        }
        .el-tabs__nav .el-tabs__item:nth-of-type(3){
            left: -10px;
            z-index: 2;
        }

        .el-tabs__item{
            padding: 0!important;
            width: 90px;
            height: 31px;
            border-right: none;


            .apple-keyword-custom-tab-pane{
                height: 30px;
                width: 90px;
                background: url("../../../../assets/img/apple-keyword-tab-pane.png") 0 0 no-repeat;
                background-size: contain;
                text-indent: -10px;
                text-align: center;
                line-height: 34px;
                font-size: 12px;
                position: relative;
            }
            &.is-active .apple-keyword-custom-tab-pane{
                background: url("../../../../assets/img/apple-keyword-tab-pane-active.png") 0 0 no-repeat;
                background-size: contain;
                &:after{
                    content: '';
                    display: block;
                    position: absolute;
                    width: 90px;
                    height: 2px;
                    background-color: red;
                }
            }
        }



    }
</style>
